<template>
<div class="main-form">
<LoginForm></LoginForm>
</div>
</template>

<script>
import LoginForm from '../components/LoginForm.vue';

export default {
  components: { LoginForm },
}
</script>
<style lang="scss">
.main-form {
  height: 100%;
}


</style> 